const colors = {
  black: "#000000",
  lightOrange: "#FFC900",
  lightYellow: "#EBE389",
  orange: "#FF9B00",
  yellow: "#FFE100",
  white: "#FFFFFF",
  primary: "hsl(358, 65%, 48.7%)",
};

export default colors;
